module.exports = __webpack_public_path__ + "img/dtx-logo.738519ef.svg";